import { forwardRef, useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore.ts'
import { useWaveform } from 'shared/ui/AudioPlayer/ui/AudioWave/hooks/useWaveform.ts'
import {
  type IUseWaveformApiRef,
  useWaveformApiRef,
} from 'shared/ui/AudioPlayer/ui/AudioWave/hooks/useWaveformApiRef.ts'
import styles from './styles.module.scss'

type IAudioWaveProps = {
  id: string
  url: string
  width?: number
  height?: number
  setDuration?: (value: number) => void
  playing: boolean
  setPlaying: (value: boolean) => void
  hide?: boolean
  autoplay?: boolean
  onErrorLoad?: (e: unknown) => void
  onLineClick?: () => void
}

const AudioWaveRef = forwardRef<IUseWaveformApiRef, IAudioWaveProps>(
  (
    {
      id,
      url,
      width,
      height = 24,
      setDuration,
      playing,
      setPlaying,
      hide,
      autoplay,
      onErrorLoad,
      onLineClick,
    },
    ref
  ) => {
    const waveformRef = useRef<HTMLDivElement>(null)
    const { waveform, onWaveformPlay } = useWaveform({
      id: id,
      url: url,
      ref: waveformRef,
      height: height,
      autoplay: autoplay,
      setPlaying: setPlaying,
      setDuration: setDuration,
      onErrorLoad: onErrorLoad,
      onLineClick: onLineClick,
    })

    useWaveformApiRef(ref, {
      waveform: waveform,
      onWaveformPlay: onWaveformPlay,
    })

    useEffect(() => {
      if (id !== uiStore.playAudioId && playing) {
        if (waveform) {
          waveform.pause()
          setPlaying(waveform?.isPlaying())
        }
      }
    }, [uiStore.playAudioId, playing])

    return (
      <div
        ref={waveformRef}
        className={styles.wrap}
        style={{ width: width || '100%', display: hide ? 'none' : '' }}
      />
    )
  }
)

AudioWaveRef.displayName = 'AudioWave'

export const AudioWave = observer(AudioWaveRef)
